import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Col, Form, Input, Row } from "antd";
import {
  setIsLoginLoading,
  setToken,
  setUserID,
  setUserName,
} from "../../Features/User/User";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { routes } from "../../Routes/Routes";
import { apiUrl } from "../../Constant";
import logo from "../../Assets/PNG/logo.png";
import styles from "./index.module.scss";

function User() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loader = useSelector((state) => state.user?.isLoginLoading);
  const [errorState, setErrorState] = useState(null); // "blocked" | "pending" | null

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const loginHandler = async (values) => {
    const payload = {
      email: values.emailOrPhone.includes("@")
        ? values.emailOrPhone
        : undefined,
      phoneNumber: !values.emailOrPhone.includes("@")
        ? values.emailOrPhone
        : undefined,
      password: values.password,
    };

    try {
      dispatch(setIsLoginLoading(true));

      // withCredentials lets the tdc_device cookie travel with the
      // request so the backend can enforce the per-user device lock.
      const res = await axios.post(apiUrl.LOGIN, payload, { withCredentials: true });

      if (res.data.type === "success") {
        const { token, user } = res.data;

        // Save to localStorage
        localStorage.setItem("token", token);
        localStorage.setItem("userId", user.id);

        // Save to redux
        dispatch(setToken(token));
        dispatch(setUserID(user.id));
        dispatch(setUserName(user.name));

        toast.success("Login successful");
        navigate(routes.homepageUrl);
      }
    } catch (error) {
      const status = error?.response?.status;
      const code = error?.response?.data?.code;
      const msg = error?.response?.data?.message || "";

      if (status === 403 && (code === "device_locked" || code === "device_limit_reached")) {
        setErrorState(null);
        toast.error(msg || "This account has reached its device limit. Contact admin to remove a device.");
      } else if (status === 403 && msg.includes("restricted")) {
        setErrorState("blocked");
      } else if (status === 403) {
        setErrorState("pending");
      } else {
        setErrorState(null);
        toast.error(msg || "Login failed");
      }
    } finally {
      dispatch(setIsLoginLoading(false));
    }
  };

  return (
    <div>
      <Row justify="center" className={styles.main}>
        <Col xl={7} xxl={7} className={styles.user}>
          <div className={styles.setuser}>
            <img
              src={logo}
              alt="The Diamond Counter"
              style={{ width: "100%", maxWidth: 220, marginBottom: 20 }}
            />

            <p className={styles.login}>Login with Email or Phone Number</p>

            {errorState === "blocked" && (
              <div style={{
                background: "#FFF3F3",
                border: "1px solid #e74c3c",
                padding: "16px 20px",
                marginBottom: 20,
                fontSize: 13,
                color: "#333",
                lineHeight: 1.6,
              }}>
                <strong style={{ color: "#e74c3c" }}>Account Restricted</strong>
                <p style={{ margin: "8px 0 0" }}>
                  Your account has been temporarily restricted. Please contact us
                  at{" "}
                  <a href="mailto:sales@thediamondcounter.com" style={{ color: "#C5A028", fontWeight: 600 }}>
                    sales@thediamondcounter.com
                  </a>{" "}
                  for assistance.
                </p>
              </div>
            )}

            {errorState === "pending" && (
              <div style={{
                background: "#FFF9E6",
                border: "1px solid #C5A028",
                padding: "16px 20px",
                marginBottom: 20,
                fontSize: 13,
                color: "#333",
                lineHeight: 1.6,
              }}>
                <strong style={{ color: "#C5A028" }}>Account Under Review</strong>
                <p style={{ margin: "8px 0 0" }}>
                  Your account is being reviewed by our team. We typically approve
                  new accounts within <strong>24 hours</strong>. You'll receive an
                  email once approved.
                </p>
              </div>
            )}

            <Form
              form={form}
              name="login-form"
              onFinish={loginHandler}
              autoComplete="off"
            >
              {/* Email / Phone */}
              <Form.Item
                name="emailOrPhone"
                className={styles.name}
                rules={[
                  { required: true, message: "Email or Phone is required" },
                ]}
              >
                <Input
                  placeholder="Email or Phone Number"
                  className={styles.phone}
                />
              </Form.Item>

              {/* Password */}
              <Form.Item
                name="password"
                rules={[{ required: true, message: "Password is required" }]}
              >
                <Input.Password
                  placeholder="Password"
                  className={styles.phone}
                />
              </Form.Item>

              <p style={{ textAlign: "right", marginBottom: 8 }}>
                <Link
                  to={routes.forgotPasswordUrl}
                  style={{ color: "#C5A028", fontSize: 13, fontWeight: 600 }}
                >
                  Forgot Password?
                </Link>
              </p>

              <p style={{ fontSize: 13, color: "#777", marginBottom: 16 }}>
                By continuing, I agree to the{" "}
                <Link to={routes.refundUrl} style={{ color: "#C5A028", fontWeight: 600 }}>
                  Terms
                </Link>{" "}
                &{" "}
                <Link to={routes.privacyUrl} style={{ color: "#C5A028", fontWeight: 600 }}>
                  Privacy Policy
                </Link>
              </p>

              <Form.Item className={styles.mainbtn}>
                <Button
                  htmlType="submit"
                  className={styles.continue}
                  loading={loader}
                >
                  Login
                </Button>
              </Form.Item>

              <p style={{textAlign: "center"}}>Don't have an account ?</p>
              <Button
                type="button"
                className={styles.continue}
                onClick={() => navigate(routes.signupUrl)}
              >
                Sign Up
              </Button>
            </Form>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default User;
